
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

export const useSubmissionDeletion = (fetchSubmissions: () => void) => {
  const deleteSubmission = async (submissionId: string) => {
    try {
      // Step 1: Verify the submission exists
      const { data: submission, error: submissionCheckError } = await supabase
        .from("terrace_submissions")
        .select("id, status, name")
        .eq("id", submissionId)
        .maybeSingle();

      if (submissionCheckError) {
        console.error("Error checking submission existence:", submissionCheckError);
        toast.error("Failed to verify submission");
        return false;
      }

      if (!submission) {
        console.warn("Submission not found:", submissionId);
        toast.error("Submission not found");
        return false;
      }

      // Step 2: Delete the submission - cascading deletes will handle related records
      // The foreign key constraints now have CASCADE DELETE for api_submissions_log
      // and SET NULL for terraces, so we can safely delete the submission
      const { error: submissionDeleteError } = await supabase
        .from("terrace_submissions")
        .delete()
        .eq("id", submissionId);

      if (submissionDeleteError) {
        console.error("Error deleting submission:", submissionDeleteError);
        toast.error("Failed to delete submission");
        return false;
      }

      toast.success(`Submission "${submission.name}" deleted successfully`);
      fetchSubmissions();
      return true;
    } catch (error) {
      console.error("Error in deletion process:", error);
      toast.error("Failed to delete submission due to an unexpected error");
      return false;
    }
  };

  return {
    deleteSubmission,
  };
};
